import CdsHeaderNavLink from 'common/components/cds-header/CdsHeaderNavLink';
import { hasAdvertising, isDevelopment } from 'env';
import AddRegistrationNumber from 'features/account-dashboard/AddRegistrationNumberContainer';
import React from 'react';

const Sidebar = () => {
  return (
    <>
      <CdsHeaderNavLink to='/dashboard' sidebar>
        Account Dashboard
      </CdsHeaderNavLink>
      <CdsHeaderNavLink to='/profile' sidebar>
        Profile, Identity, Account Settings
      </CdsHeaderNavLink>
      <CdsHeaderNavLink to='/apply-for-registration' sidebar>
        Apply for a Registration Number
      </CdsHeaderNavLink>
      <AddRegistrationNumber isSidebar />
      {hasAdvertising && (
        <CdsHeaderNavLink to='/advertising-platform' sidebar>
          {'Advertising Platform'}
        </CdsHeaderNavLink>
      )}
      {isDevelopment && (
        <CdsHeaderNavLink to='/dev-sandbox' sidebar>
          Dev Sandbox
        </CdsHeaderNavLink>
      )}
    </>
  );
};

export default Sidebar;
